'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useAppDispatch, useAppSelector } from '@/shared/providers/store'
import { setCurrentRoute, selectCurrentRoute, selectRouteInfo } from '@/shared/providers/state/navigationSlice'

/**
 * Hook that automatically updates navigation state based on current route
 * This integrates Next.js routing with Redux navigation state
 */
export const useRouteNavigation = () => {
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const currentRoute = useAppSelector(selectCurrentRoute)
  const routeInfo = useAppSelector(selectRouteInfo)

  // Update navigation state when route changes
  useEffect(() => {
    if (pathname !== currentRoute) {
      dispatch(setCurrentRoute(pathname))
    }
  }, [pathname, currentRoute, dispatch])

  return {
    currentRoute: pathname,
    routeInfo,
    breadcrumbs: routeInfo.breadcrumbs,
    title: routeInfo.title,
    description: routeInfo.description
  }
}
